import { Link, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { BrandLogoLink } from '../../components/BrandLogo';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { getCheckoutPlanSummary } from '../../constants/pricing';
import { openPaddleCheckout } from '../../lib/paddle';
import './CheckoutPage.css';

export function CheckoutPage() {
  const [params] = useSearchParams();
  const priceId = params.get('priceId');
  const planSummary = getCheckoutPlanSummary(priceId);
  useDocumentTitle('Checkout');

  useEffect(() => {
    if (!priceId) return;

    let cancelled = false;

    void openPaddleCheckout(priceId, () => cancelled);

    return () => {
      cancelled = true;
    };
  }, [priceId]);

  return (
    <div className="checkout-page">
      <header className="checkout-page__header">
        <BrandLogoLink className="brand-logo--header" mobileAppIcon />
      </header>

      <main className="checkout-page__main">
        <div className="checkout-page__card">
          {priceId ? (
            <>
              {planSummary && (
                <div className="checkout-header">
                  <h2>{planSummary.title}</h2>
                  <p>{planSummary.priceLabel}</p>
                </div>
              )}
              <div className="checkout-page__paddle checkout-container" />
            </>
          ) : (
            <p className="checkout-page__empty">
              No plan selected. Choose a plan from pricing to continue.
            </p>
          )}
          <p className="checkout-page__back">
            <Link to="/#pricing">← Back to pricing</Link>
          </p>
        </div>
      </main>
    </div>
  );
}
